import { createFileRoute } from "@tanstack/react-router";

import { OAuthConsentPage } from "~/pages/oauth/consent.page";

export const Route = createFileRoute("/oauth/consent")({
  // Pass search params through untouched. The signed OAuth authorization query
  // lives here and is read straight from `window.location.search` (and
  // auto-forwarded by `oauthProviderClient`), so it must not be narrowed.
  validateSearch: (search: Record<string, unknown>) => search,
  component: OAuthConsentPage,
});
